var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:['add-to-jinglebox', {on: _vm.status}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.toggleSelectionItem.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }